import { render } from "./BaseSelect.vue?vue&type=template&id=8d4e6caa&scoped=true"
import script from "./BaseSelect.vue?vue&type=script&lang=ts"
export * from "./BaseSelect.vue?vue&type=script&lang=ts"

import "./BaseSelect.vue?vue&type=style&index=0&id=8d4e6caa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8d4e6caa"

export default script